import styled from 'styled-components'

import { breakpoint } from '@sketch/global-styles'
import Filter, { FilterProps } from 'components/Filter'

const StyledFilter = styled(Filter)`
  min-width: 170px;

  input[type='text'] {
    background: white;
  }

  ${breakpoint('xs')`
    max-width: 300px;
  `}
`
export interface NavbarFilterProps extends FilterProps {}
export default StyledFilter
